import { ReactNode } from 'react';
import { Button } from '../../../../core/components/atoms/Button';
import { useScreenSize } from '../../../../core/hooks/useScreenSize';
import { useWindowBreakpoints } from '../../../../core/hooks/useWindowBreakpoints';
import { useUserStore } from '../../../Auth/stores/authStore';

interface CourseHeaderProps {
  backgroundImage: string | null;
  children: ReactNode;
  showButtonHeader?: boolean;
  textButtonHeader?: string;
  moveHeaderOnMobile?: boolean;
  handleClickButtonHeader?: () => any;
  className?: string;
}

const CourseHeader = ({
  backgroundImage,
  children,
  className,
  showButtonHeader,
  textButtonHeader,
  moveHeaderOnMobile = false,
  handleClickButtonHeader,
}: CourseHeaderProps) => {
  const windowBreakpoints = useWindowBreakpoints();
  const screenSize = useScreenSize();

  const { user } = useUserStore();

  return (
    <>
      <section
        className={`relative bg-cover bg-center bg-no-repeat ${className} min-h-[25vh]`}
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.00), rgba(0, 0, 0, 0.80)), url(${backgroundImage})`,
        }}
      >
        {showButtonHeader && (
          <Button
            variant='text'
            className='font-noto absolute bottom-4 right-6 top-[unset] text-md font-normal md:bottom-[unset] md:top-12'
            LeftIcon={screenSize < windowBreakpoints.md ? '' : 'settings'}
            iconType='material'
            negative={!user?.isDarkMode}
            onClick={handleClickButtonHeader}
          >
            {' '}
            {textButtonHeader}{' '}
          </Button>
        )}
        {(screenSize >= windowBreakpoints.md || !moveHeaderOnMobile) && (
          <div className='mx-auto flex h-[212px] max-w-screen-xl items-end px-20 pb-0 sm:h-[420px] sm:px-5 sm:pb-10 md:px-20 2xl:px-0'>
            {children}
          </div>
        )}
      </section>
      {screenSize < windowBreakpoints.md && moveHeaderOnMobile && (
        <div className='mx-auto flex max-w-screen-xl items-end px-4 py-8 pb-0'>
          {children}
        </div>
      )}
    </>
  );
};

export default CourseHeader;
